<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div slot="header" class="title_head">Search Shop User</div>
      <b-collapse id="collapse1" visible>
        <b-card-body>
          <div class="row">
            <div class="col-sm-12">
              <div v-if="hasErrors.message" class="alert alert-success">
                <center><strong></strong>{{ errorMessage.message }}</center>
              </div>
            </div>
          </div>
          <b-row>
            <b-col sm="3">
              <b-form-group>
                <label for="name"> User Name </label>
                <b-form-input
                  type="text"
                  v-model="user.names"
                  placeholder="Enter your name"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group>
                <label for="name">Email </label>
                <b-form-input
                  type="text"
                  v-model="user.email1"
                  placeholder="Enter your Email Address"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group>
                <label for="name">Shop Establishment ID </label>
                <model-list-select
                  :list="shopidopt1"
                  option-value="est_shop_name"
                  style="
                    -webkit-text-fill-color: rgb(83, 108, 121) !important;
                    height: 20px !important;
                    border: 1px solid rgb(194, 207, 214);
                    min-height: 35px;
                  "
                  option-text="est_shop_name"
                  v-model="shopids"
                  placeholder="Select Shop Establishment ID"
                ></model-list-select>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <button
                v-if="u_view === true"
                type="button"
                style="margin-top: 24px; margin-left: 16%;"
                class="btn btn-pill btn-primary serach_bttn"
                @click.prevent="shopuser"
              >
                <i class="fa fa-search"></i>&nbsp;Search
              </button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body>
      <div class="card-header">
        <span class="title_head">List User's</span>&nbsp;&nbsp;
        <span v-if="u_rights === true"
          ><button
            type="button"
            class="btn btn-sm btn-primary label_bttn"
            variant="secondary"
            @click="addusers"
          >
            <i class="fa fa-plus"></i> Add User
          </button></span
        >
      </div>

      <b-collapse id="collapse1" visible>
        <b-card-body>
          <vue-good-table
            :columns="columns"
            :rows="rows"
            mode="remote"
            ref="my-table"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange"
            :totalRows="totalRecords"
            :pagination-options="{ enabled: true, perPage: 5 }"
            styleClass="vgt-table striped bordered table-sm condensed"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'action'">
                <i class="fa fa-edit" @click.prevent="editpro(props.row)"></i>
              </span>
              <span v-if="props.column.field == 'status'">
                <div v-if="props.row.status == '1'">
                  <b-badge variant="success">Active</b-badge>
                </div>
                <div v-else>
                  <b-badge variant="danger">In Active</b-badge>
                </div>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>

          <b-modal
            title="User Detail"
            no-close-on-esc
            no-close-on-backdrop
            size="lg"
            class="modal-info"
            hide-footer
            v-model="largeModal"
            @ok="largeModal = false"
          >
            <b-row>
              <b-col sm="12">
                <div v-if="hasErrors.err_message" class="alert alert-success">
                  <center>{{ errorMessage.err_message }}</center>
                </div>
              </b-col>
            </b-row>

            <b-form-group
              v-if="isSuperAdmin === false"
              style="text-align: right;"
            >
              <label for="name">Status </label>
              &nbsp;&nbsp;&nbsp;<label
                class="switch switch-text switch-pill switch-primary"
                ><input
                  type="checkbox"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Tooltip on top"
                  class="switch-input"
                  :true-value="true"
                  :false-value="false"
                  v-model="checkbox" />
                <span
                  data-on="Active"
                  data-off="Inactive"
                  class="switch-label"
                ></span>
                <span class="switch-handle"></span
              ></label>
            </b-form-group>

            <b-form-group
              v-if="isSuperAdmin === true"
              style="text-align: right;"
            >
              <label for="name">Activate/Deactivate Account </label>
              &nbsp;&nbsp;&nbsp;<label
                class="switch switch-text switch-pill switch-primary"
                ><input
                  type="checkbox"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Tooltip on top"
                  class="switch-input"
                  v-on:change="account_status"
                  :true-value="true"
                  :false-value="false"
                  v-model="active_deactive" />
                <span
                  data-on="Active"
                  data-off="Deactive"
                  class="switch-label"
                ></span>
                <span class="switch-handle"></span
              ></label>
            </b-form-group>

            <b-row>
              <b-col sm="4">
                <b-form-group>
                  <label for="name"
                    >User Name<span style="color: red;">*</span>
                  </label>
                  <b-form-input
                    type="text"
                    :class="{ 'is-invalid': hasErrors.usernm }"
                    v-model="user.name"
                    placeholder="Enter your name"
                    autocomplete="off"
                    v-on:keyup.native="onComplete('false', 'uname')"
                  ></b-form-input>
                  <small class="form-text text-muted" v-if="hasErrors.usernm"
                    ><strong style="color: red;">{{
                      hasErrors.usernm
                    }}</strong></small
                  >
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="name"
                    >Email <span style="color: red;">*</span></label
                  >
                  <div v-if="updateedit === 0">
                    <b-form-input
                      type="text"
                      :class="{ 'is-invalid': hasErrors.usereml }"
                      autocomplete="off"
                      v-model="user.email"
                      placeholder="Enter your email"
                      v-on:keyup.native="onComplete('false', 'eml')"
                    ></b-form-input>
                  </div>
                  <div v-else>
                    <b-form-input
                      type="text"
                      :class="{ 'is-invalid': hasErrors.usereml }"
                      autocomplete="off"
                      :value="user.email"
                      readonly
                      placeholder="Enter your email"
                    ></b-form-input>
                  </div>
                  <small class="form-text text-muted" v-if="hasErrors.usereml"
                    ><strong style="color: red;">{{
                      hasErrors.usereml
                    }}</strong></small
                  >
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="name"
                    >Contact Number <span style="color: red;">*</span></label
                  >
                  <b-form-input
                    type="text"
                    name="phone"
                    :class="{ 'is-invalid': hasErrors.userph }"
                    v-model="user.phone"
                    placeholder="Enter your contact number"
                    autocomplete="off"
                    v-on:keyup.native="onComplete('false', 'phn')"
                  ></b-form-input>
                  <small class="form-text text-muted" v-if="hasErrors.userph"
                    ><strong style="color: red;">{{
                      hasErrors.userph
                    }}</strong></small
                  >
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group>
                  <label for="name"
                    >Password <span style="color: red;">*</span></label
                  >
                  <div>
                    <b-form-input
                      type="password"
                      :class="{ 'is-invalid': hasErrors.password }"
                      v-model="user.pass"
                      placeholder="Enter your name"
                      autocomplete="off"
                      v-on:keyup.native="onComplete('false', 'psw')"
                    ></b-form-input>
                  </div>
                  <small class="form-text text-muted" v-if="hasErrors.password"
                    ><strong style="color: red;">{{
                      hasErrors.password
                    }}</strong></small
                  >
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="name"
                    >Confirm Password <span style="color: red;">*</span></label
                  >

                  <b-form-input
                    type="password"
                    name="conf"
                    :class="{ 'is-invalid': hasErrors.confpassword }"
                    v-model="user.conf"
                    placeholder="Enter your ConfirmPassword"
                    autocomplete="off"
                    @input="onComplete('false', 'cnfpsw')"
                  ></b-form-input>

                  <small
                    class="form-text text-muted"
                    v-if="hasErrors.confpassword"
                    ><strong style="color: red;">{{
                      hasErrors.confpassword
                    }}</strong></small
                  >
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="4"> </b-col>
            </b-row>

            <b-row v-if="isSuperAdmin === false">
              <b-col sm="12">
                <label>Select Shops</label>
                <vue-good-table
                  id="shoplist"
                  ref="myShopTable"
                  @on-page-change="onPageChangeShop"
                  @on-sort-change="onSortChangeShop"
                  @on-column-filter="onColumnFilterShop"
                  @on-per-page-change="onPerPageChangeShop"
                  @on-selected-rows-change="selectedShops($event)"
                  :totalRows="totalRecordsShop"
                  :columns="columnsadj"
                  :rows="rowsadj"
                  :select-options="{
                    enabled: true,
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                  }"
                  styleClass="vgt-table striped bordered table-sm condensed"
                  :pagination-options="{ enabled: true, perPage: 5 }"
                >
                  <template slot="table-row" slot-scope="props">
                    {{ props.formattedRow[props.column.field] }}
                  </template>
                  <div slot="emptystate">
                    No Data
                  </div>
                </vue-good-table>
              </b-col>
            </b-row>
            <small class="form-text text-muted" v-if="errorMessage.usershop"
              ><strong style="color: red;">{{
                errorMessage.usershop
              }}</strong></small
            >
            <b-row style="padding-top: 20px;" v-if="isSuperAdmin === false">
              <b-col sm="12">
                <label>Select Roles</label>

                <vue-good-table
                  :columns="column1"
                  :rows="rows1"
                  :totalRows="totalRecordsRoles"
                  :search-options="{ enabled: true }"
                  @on-row-click="selectedRoles"
                  :select-options="{ enabled: true }"
                  @on-page-change="onPageChangeRole"
                  @on-sort-change="onSortChangeRole"
                  @on-column-filter="onColumnFilterRole"
                  @on-per-page-change="onPerPageChangeRole"
                  styleClass="vgt-table striped bordered table-sm condensed"
                  :pagination-options="{ enabled: true, perPage: 10 }"
                >
                  <template slot="table-row" slot-scope="props">
                    {{ props.formattedRow[props.column.field] }}
                  </template>
                </vue-good-table>

                <!--<b-form-radio-group id="radioRole" v-model="roleList" :options="rows1" name="radio-options"></b-form-radio-group> @on-selected-rows-change="selectedRoles($event)"-->
              </b-col>
            </b-row>
            <small class="form-text text-muted" v-if="errorMessage.userrole"
              ><strong style="color: red;">{{
                errorMessage.userrole
              }}</strong></small
            >
            <div class="card-footer modal_footer">
              <b-row>
                <b-col sm="4">
                  <b-button-group>
                    <button
                      v-if="u_rights === true"
                      type="submit"
                      class="btn btn-sm btn-primary"
                      @click.prevent="Submit()"
                    >
                      <i class="fa fa-dot-circle-o"></i> Save
                    </button>
                  </b-button-group>
                </b-col>
              </b-row>
            </div>
          </b-modal>
          <b-modal
            title="Please Confirm"
            size="sm"
            class="modal-warning"
            v-model="deact_modal"
            ok-variant="danger"
            ok-title="Yes, Deactivate it"
            @ok="handleOk"
          >
            <b-row>
              <!-- <b-col sm="2">
            </b-col> -->
              <b-col sm="2">
                <i
                  class="fa fa-exclamation"
                  style="font-size: 40px; color: red;"
                ></i>
              </b-col>
              <b-col sm="10">
                <b-row>
                  <b>Are you Sure, you want to deactivate your account?</b>
                </b-row>
                <b-row>
                  Deactivating your account will disable your account and you
                  will not be able to login again.
                </b-row>
              </b-col>
            </b-row>
          </b-modal>
          <b-modal
            title="Plan Limit Reached"
            size="sm"
            class="modal-warning"
            ok-only
            v-model="plan_modal"
          >
            <b-row>
              <b-col sm="2">
                <i
                  class="fa fa-exclamation"
                  style="font-size: 40px; color: red;"
                ></i>
              </b-col>
              <b-col sm="10">
                <b-row>
                  <b>You have hit the plan limit.</b>
                </b-row>
                <b-row>
                  You have reached the limit of adding User. Please upgrade your
                  plan to add more Users.
                </b-row>
              </b-col>
            </b-row>
          </b-modal>
        </b-card-body>
      </b-collapse>
    </b-card>

    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
import Spinner from "../../spinner.vue";
export default {
  name: "user",
  components: { Spinner },
  data() {
    return {
      // ufrst_time:false,
      active_deactive: true,
      plan_modal: false,
      rfrst_time: false,
      shpfrst_time: false,
      estfrst_time: false,
      isSuperAdmin: false,
      deact_modal: false,
      columnsadj: [
        {
          label: "Shop Name",
          field: "est_shop_name",
          width: "30%",
        },
        {
          label: "Address",
          field: "address1",
          width: "60%",
        },
      ],
      rowsadj: [],
      column1: [
        {
          label: "Role",
          field: "role_name",
          width: "90%",
        },
      ],
      totalRecords: 0,
      totalRecordsShop: 0,
      totalRecordsRoles: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5,
      },
      serverParamsShop: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5,
      },
      serverParamsRole: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      rows1: [],
      tempshpList: null,
      shopList: [],
      beforeShops: [],
      deletedshops: [],
      // roleList:[],
      roleList: null,
      isAdmin: false,
      submit_true: 0,
      options1: [
        { text: "Admin User", value: "2" },
        { text: "Normal User", value: "3" },
      ],
      options2: [{ text: "Normal User", value: "3" }],
      options3: [{ text: "Please select", value: "" }],
      items: [],
      lastSelectItem: {},
      checkbox: 1,
      shopids: null,
      largeModal: false,
      largeModal1: false,
      loading: false,
      usertype: "",
      updateedit: 0,
      temprow: null,
      shopidopt: [],
      allUser: [],
      shoplist1: [],
      rolelist1: [],
      // totalRecords:[],
      user: {
        name: "",
        address: "",
        pincode: "",
        email: "",
        email1: "",
        pass: "",
        conf: "",
        phone: "",
        names: "",
        editid: null,
      },
      columns: [
        {
          label: "User Name",
          field: "user_name",
          width: "20%",
        },
        {
          label: "User Email",
          field: "user_email",
          width: "30%",
        },
        {
          label: "Contact No.",
          field: "phonenumber",
          width: "30%",
        },
        {
          label: "Status",
          field: "status",
          width: "10%",
        },
        {
          label: "Action",
          field: "action",
          width: "10%",
        },
      ],
      rows: [],
      shopid: null,
      shopidopt1: [],
      hasErrors: {
        err_message: "",
        message: "",
        password: "",
        usernm: "",
        useradd: "",
        userpin: "",
        usereml: "",
        userph: "",
      },
      errorMessage: {
        err_message: null,
        message: null,
        usertypeerr: null,
        usershop: null,
        userrole: null,
      },
    };
  },

  computed: {
    u_view: function () {
      if (this.$store.getters.get_u_view === true) {
        this.shopest("comp");
        this.shopuser("comp");
        this.role("comp");
        return true;
        // this.usertypess('comp')
        // Promise.all([this.shopest('comp'),this.shopuser('comp'),this.role('comp')]).then(ret_val => {
        //   return true
        // });
      } else {
        return false;
      }
    },
    u_rights: function () {
      return this.$store.getters.get_u_rights;
    },
  },

  methods: {
    handleOk(event) {
      // Prevent modal from closing
      event.preventDefault();
      // Trigger submit handler
      this.deactivate_acc();
    },

    deactivate_acc() {
      var _this = this;
      this.loading = true;
      let res = {
        status: false,
        locked: false,
      };
      this.$http
        .post("/api/users/update", res)
        .then(function (response) {
          if (response.status === 200) {
            alert("your account has been deactivated");
            _this.loading = false;
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        })
        .catch(function (error) {
          _this.loading = false;
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        });
    },

    account_status() {
      if (this.active_deactive === false) {
        this.active_deactive = true;
        this.deact_modal = true;
      }

      // var r = confirm(
      //   "Are you sure you want to deactivate the User Account? Once the account is been Deactivated,you want be able to use the account"
      // );
      // if (r == true) {
      //   var _this = this;
      //   this.loading = true;
      //   let res = {
      //     status: false,
      //     locked: false,
      //   };
      //   this.$http
      //     .post("/api/users/update", res)
      //     .then(function (response) {
      //       if (response.status === 200) {
      //         alert("your account has been deactivated");
      //         console.log(response);
      //         _this.loading = false;
      //         localStorage.clear();
      //         _this.$store.commit("SET_AUTH_USER", null);
      //         _this.$router.push("/");
      //       }
      //     })
      //     .catch(function (error) {
      //       _this.loading = false;
      //       localStorage.clear();
      //       _this.$store.commit("SET_AUTH_USER", null);
      //       _this.$router.push("/");
      //     });
      // }
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.shopuser();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.shopuser();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.shopuser();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.shopuser();
    },

    updateParamsShop(newProps) {
      this.serverParamsShop = Object.assign(
        {},
        this.serverParamsShop,
        newProps
      );
    },

    onPageChangeShop(params) {
      this.updateParamsShop({ page: params.currentPage });
      // this.editpro(_this.tempuser);
    },

    onPerPageChangeShop(params) {
      this.updateParamsShop({ perPage: params.currentPerPage, page: 1 });
      // this.editpro(_this.tempuser);
    },

    onSortChangeShop(params) {
      this.updateParamsShop({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      // this.shopuser();
    },

    onColumnFilterShop(params) {
      this.updateParamsShop(params);
      // this.shopuser();
    },

    updateParamsRole(newProps) {
      this.serverParamsRole = Object.assign(
        {},
        this.serverParamsRole,
        newProps
      );
    },

    onPageChangeRole(params) {
      this.updateParamsRole({ page: params.currentPage });
      this.role();
    },

    onPerPageChangeRole(params) {
      this.updateParamsRole({ perPage: params.currentPerPage, page: 1 });
      this.role();
    },

    onSortChangeRole(params) {
      this.updateParamsRole({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.role();
    },

    onColumnFilterRole(params) {
      this.updateParamsRole(params);
      // this.shopuser();
    },
    // onSelect (items, lastSelectItem) {
    //   this.items = items
    //   this.lastSelectItem = lastSelectItem
    // },

    checkEmail(email) {
      var _this = this;
      return this.$http
        .get("/api/users/" + email + "/exists")
        .then(function (response) {
          return response.data.exists;
        })
        .catch(function (error) {
          return null;
        });
    },

    chkphone(phone) {
      var _this = this;
      return this.$http
        .get("/api/users/phone_exist/" + phone)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          return true;
        });
    },

    onComplete(chk, val) {
      var _this = this;
      this.submit_true = 0;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      var regex = /^[a-zA-Z0-9\s]{3,100}$/;
      var mobregex = /^[0-9]{10,15}$/;
      var passcheck = /^((?!.*[\s])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20})$/;
      var eregex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)[a-z0-9]{2,3}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

      if (val == "uname" || chk == "check") {
        if (this.user.name.length < 3) {
          if (!this.user.name) {
            this.hasErrors.usernm = "Required";
          } else {
            this.hasErrors.usernm = "Enter Minimum 3 Characters";
          }
          this.submit_true = 1;
        } else if (this.user.name.length > 100) {
          this.hasErrors.usernm = "Enter Minimum 3 Characters";
          this.submit_true = 1;
        } else {
          this.hasErrors.usernm = "";
        }
      }

      if (val == "utype" || chk == "check") {
        if (!this.usertype) {
          this.errorMessage.usertypeerr = "Required";
          this.submit_true = 1;
        } else {
          this.errorMessage.usertypeerr = "";
        }
      }

      if (val == "psw" || chk == "check") {
        if (passcheck.test(this.user.pass) == false) {
          if (!this.user.pass) {
            this.hasErrors.password = "Required";
          } else {
            this.hasErrors.password =
              "8 characters including 1 uppercase letter, 1 special character & alphanumeric characters without space";
          }
          this.submit_true = 1;
        } else {
          this.hasErrors.password = "";
        }
      }

      if (val == "eml" || chk == "check") {
        if (eregex.test(this.user.email) == false) {
          if (!this.user.email) {
            this.hasErrors.usereml = "Required";
          } else {
            this.hasErrors.usereml = "Enter valid email";
          }
          this.submit_true = 1;
        } else if (this.user.email.length > 70) {
          this.hasErrors.usereml = "Maximum 70 characters";
        } else {
          this.hasErrors.usereml = "";
        }
      }

      if (val == "phn" || chk == "check") {
        if (!this.user.phone) {
          this.hasErrors.userph = "Required";
          this.submit_true = 1;
        } else if (mobregex.test(this.user.phone) == false) {
          this.hasErrors.userph = "Invalid Contact number";
          this.submit_true = 1;
        } else {
          if (this.updateedit == 0) {
            Promise.all([this.chkphone(this.user.phone)]).then((user) => {
              if (user[0] == true) {
                this.hasErrors.userph = "This Number Alerady Exist";
                this.submit_true = 1;
              } else {
                this.hasErrors.userph = "";
              }
            });
          } else {
            if (this.user.phone !== this.temprow.phonenumber) {
              Promise.all([this.chkphone(this.user.phone)]).then((user) => {
                if (user[0] == true) {
                  this.hasErrors.userph = "This Number Alerady Exist";
                  this.submit_true = 1;
                } else {
                  this.hasErrors.userph = "";
                }
              });
            }
          }
        }
      }

      if (val == "cnfpsw" || chk == "check") {
        if (this.user.conf == "") {
          this.hasErrors.confpassword = "Required";
          this.submit_true = 1;
        } else if (this.user.pass != this.user.conf) {
          this.hasErrors.confpassword =
            "Password & ConfirmPassword Does Not Match";
          this.submit_true = 1;
        } else {
          this.hasErrors.confpassword = "";
        }
      }

      if (chk == "check") {
        if (this.shopList.length == 0) {
          this.errorMessage.usershop = "Please Provide Shop";
          this.submit_true = 1;
        } else {
          this.errorMessage.usershop = "";
        }
        // if(this.roleList.length==0){
        //   this.errorMessage.userrole="Please Provide Role"
        //   this.submit_true=1
        // }else{
        //   this.errorMessage.userrole=''
        // }
        if (this.roleList === null || this.roleList == "") {
          this.errorMessage.userrole = "Please Provide Role";
          this.submit_true = 1;
        } else {
          this.errorMessage.userrole = "";
        }
      }
    },

    selectedShops(shop) {
      this.deletedshops = [];
      var a = [];
      var b = [];
      var c = [];
      for (var i = 0; i < this.rowsadj.length; i++) {
        a.push(this.rowsadj[i].est_shop_id);
      }

      var len = shop.selectedRows.length;
      var _this = this;
      this.shopList = [];
      for (var i = 0; i < len; i++) {
        var temp = shop.selectedRows[i];
        _this.shopList.push(temp.est_shop_id);
        b.push(temp.est_shop_id);
      }

      for (var i = 0; i < a.length; i++) {
        var ind = b.indexOf(a[i]);
        if (ind == -1) {
          c.push(a[i]);
        }
      }

      this.deletedshops = c;
    },

    selectedRoles(role) {
      for (var i = 0; i < this.rows1.length; i++) {
        this.$set(this.rows1[i], "vgtSelected", false);
        if (this.rows1[i].role_id == role.row.role_id) {
          this.$set(this.rows1[i], "vgtSelected", true);
        }
      }
      // if(role.row.role_id == 'I2OC1'){
      //   this.isAdmin = true
      // }
      // var len = role.selectedRows.length
      // var _this = this
      // this.roleList =[]
      // for(var i=0;i<len;i++){
      //   var temp = role.selectedRows[i]
      //   if(temp.role_id == 'I2OC1'){
      //     _this.isAdmin = true
      //   }
      //   _this.roleList.push({role_id:temp.role_id})
      // }
      this.roleList = role.row.role_id;
    },

    reset() {
      this.items = []; // reset
    },

    selectFromParentComponent() {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual);
    },

    addusers() {
      var _this = this;
      this.loading = true;
      this.$http
        .get("/api/users/chk_plan_count")
        .then(function (response) {
          _this.loading = false;
          if ("message" in response.data) {
            if (response.data.message === false) {
              var x = document.getElementsByClassName("vgt-checkbox-col");
              for (var i = 0; i < x.length; i++) {
                x[i].style.width = "0.1%";
              }
              _this.hasErrors.usernm = "";
              _this.hasErrors.useradd = "";
              _this.hasErrors.userpin = "";
              _this.hasErrors.usereml = "";
              _this.hasErrors.userph = "";
              _this.hasErrors.password = "";
              _this.hasErrors.confpassword = "";
              _this.errorMessage.usershop = "";
              _this.errorMessage.usertypeerr = "";
              _this.errorMessage.userrole = "";
              _this.user.name = "";
              _this.user.email = "";
              _this.user.phone = "";
              _this.user.pass = "";
              _this.user.conf = "";
              _this.updateedit = 0;
              _this.checkbox = 1;
              _this.shopid = null;
              _this.address = "";
              _this.shopList = null;
              _this.roleList = null;
              _this.deletedshops = [];
              _this.updateedit = 0;
              _this.editid = null;
              _this.hasErrors.message = false;
              _this.errorMessage.message = null;
              _this.usertype = "3";
              _this.temprow = null;
              for (var k = 0; k < _this.rowsadj.length; k++) {
                _this.$set(_this.rowsadj[k], "vgtSelected", false);
              }
              for (var k = 0; k < _this.rows1.length; k++) {
                _this.$set(_this.rows1[k], "vgtSelected", false);
              }
              _this.plan_modal = false;
              _this.largeModal = true;
            } else {
              _this.plan_modal = true;
            }
          } else {
            console.log("something went wrong");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    shopest(val) {
      if (val === "comp") {
        if (this.estfrst_time === false) {
          this.estfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http
        .get("/api/shopestablishments/find_user_shop")
        .then(function (response) {
          _this.tempshpList = response.data;
          _this.rowsadj = response.data;
          _this.shopidopt1 = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    role(val) {
      if (val === "comp") {
        if (this.rfrst_time === false) {
          this.rfrst_time = true;
        } else {
          return false;
        }
      }
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParamsRole.page;
      filteParam.perPage = this.serverParamsRole.perPage;
      filteParam.sort = this.serverParamsRole.sort;
      this.$http
        .get("/api/roletbs?params=" + JSON.stringify(filteParam))
        .then(function (response) {
          // _this.rolelist1 = response.data;
          // var _rows1 = []
          // for(var i=0;i<response.data.length;i++){
          //   _rows1.push({ 'text': response.data[i].role_id, 'value': response.data[i].role_name})
          // }
          // _this.rows1 = _rows1;
          // console.log(response.data)
          // _this.rows1 = response.data

          // console.log(response.data)
          if (response.data != undefined) {
            _this.totalRecordsRoles = response.data[0].totalRecords;
            response.data.shift();
            _this.rows1 = response.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    shopuser(val) {
      var _this = this;
      this.allUser = [];
      // this.rows.length = 0
      var filteParam = {};

      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }

      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var data = [];
      var supname = this.user.names;
      supname = supname.split(" ").join("_");
      if (this.user.names != "") {
        data = data + "&filter[where][user_name][ilike]=%" + supname + "%";
      }
      if (this.user.email1 != "") {
        data =
          data + "&filter[where][user_email][ilike]=%" + this.user.email1 + "%";
      }
      if (this.shopids != null) {
        data = data + "&filter[where][est_shop_id]=" + this.shopids.est_shop_id;
      }
      this.loading = true;
      this.$http
        .get(
          "/api/shopusers/getShopUser?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          _this.allUser = response.data;
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          if (response.data != undefined) {
            _this.rows.length = 0;
            _this.rows = response.data;
          }

          _this.loading = false;
        })
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },

    editpro(row) {
      this.temprow = row;
      this.roleList = null;
      for (var k = 0; k < this.rowsadj.length; k++) {
        this.$set(this.rowsadj[k], "vgtSelected", false);
      }
      for (var k = 0; k < this.rows1.length; k++) {
        this.$set(this.rows1[k], "vgtSelected", false);
      }
      // console.log(row)
      var x = document.getElementsByClassName("vgt-checkbox-col");
      for (var i = 0; i < x.length; i++) {
        x[i].style.width = "0.1%";
      }
      if (row.est_user_type == "1") {
        this.isSuperAdmin = true;
      } else {
        this.isSuperAdmin = false;
      }
      this.user.name = row.user_name;
      this.user.email = row.user_email;
      this.user.phone = row.phonenumber;
      this.usertype = 3;
      this.user.pass = row.password;
      this.user.conf = row.password;
      this.checkbox = row.status;
      this.updateedit = 1;
      this.editid = row.user_email;
      this.hasErrors.message = false;
      this.errorMessage.message = null;
      var _this = this;
      _this.hasErrors.usernm = "";
      _this.hasErrors.useradd = "";
      _this.hasErrors.userpin = "";
      _this.hasErrors.usereml = "";
      _this.hasErrors.userph = "";
      _this.hasErrors.password = "";
      _this.hasErrors.confpassword = "";
      _this.errorMessage.usershop = "";
      _this.errorMessage.usertypeerr = "";
      _this.errorMessage.userrole = "";
      var temp = row.user_email;
      // this.rowsadj=[]
      var temparr = [];
      var temprole = [];

      //user roles
      Promise.all([
        this.setUserShop(row.user_email),
        this.setUserRole(row.user_email),
      ]).then((ret_val) => {
        _this.largeModal = true;
      });

      // this.$http.get('/api/userroles?filter[where][est_user_id]='+row.user_email).then(function (response){

      //   for(var k=0;k<_this.rows1.length;k++){
      //     if(_this.rows1[k].role_id == response.data[0].role_id){
      //         _this.$set(_this.rows1[k], 'vgtSelected', true);
      //     }
      //    }
      //   temprole = response.data;
      //   if(temprole.length != 0){
      //     _this.rows1=[]
      //     for(var i=0;i<_this.rolelist1.length;i++){
      //       for(var j=0;j<temprole.length;j++){
      //         if(_this.rolelist1[i].role_id == temprole[j].role_id){
      //           _this.rows1.push({role_id:_this.rolelist1[i].role_id,role_name:_this.rolelist1[i].role_name,vgtSelected:true})
      //           break
      //         }
      //         if(j == parseInt(temprole.length)-1){
      //           _this.rows1.push({role_id:_this.rolelist1[i].role_id,role_name:_this.rolelist1[i].role_name,vgtSelected:false})
      //         }
      //       }
      //     }
      //   }else{
      //     _this.rows1=[]
      //     _this.roleList = ''
      //     // if(_this.rolelist1.length!=0){
      //     //   for(var k = 0;k<_this.rolelist1.length;k++){
      //     //     _this.rows1.push({role_id:_this.rolelist1[k].role_id,role_name:_this.rolelist1[k].role_name,vgtSelected:false})
      //     //   }
      //     // }
      //   }
      // }).catch(function(err){
      //   console.log('Something Went Wrong')
      // })

      //user shops

      // this.$http.get('/api/shopusers?filter[where][est_user_id]='+row.user_email).then(function (response){
      //   console.log('shop')
      //   console.log(response.data)
      //   console.log(_this.rowsadj[0])

      //   for(var k=0;k<_this.rowsadj.length;k++){
      //     for(var j=0;j<response.data.length;j++){
      //       if(_this.rowsadj[k].est_shop_id == response.data[j].est_shop_id){
      //         _this.$set(_this.rowsadj[k], 'vgtSelected', true);
      //         break;
      //       }
      //     }
      //    }
      /*
        var userShopList = response.data
        if(userShopList.length != 0){
          _this.rowsadj=[]
          for(var i=0;i<_this.tempshpList.length;i++){
            for(var j=0;j<userShopList.length;j++){
              if(userShopList[j].shopestablishments.est_shop_id == _this.tempshpList[i].est_shop_id && temp==userShopList[j].user_email){
                _this.rowsadj.push({est_shop_id:_this.tempshpList[i].est_shop_id,est_shop_name:_this.tempshpList[i].est_shop_name,address1:_this.tempshpList[i].address1,vgtSelected:true})
                break;
              }
              if(j == parseInt(userShopList.length)-1){
                _this.rowsadj.push({est_shop_id:_this.tempshpList[i].est_shop_id,est_shop_name:_this.tempshpList[i].est_shop_name,address1:_this.tempshpList[i].address1,vgtSelected:false})
              }
            }
          }
        }else{
          _this.rowsadj.push({est_shop_id:_this.tempshpList[i].est_shop_id,est_shop_name:_this.tempshpList[i].est_shop_name,address1:_this.tempshpList[i].address1,vgtSelected:false})
        }*/
      // })
    },

    async setUserShop(email) {
      // console.log('setUserShop')
      // console.log(email)
      var _this = this;
      this.$http
        .get("/api/shopusers?filter[where][est_user_id]=" + email)
        .then(function (response) {
          _this.beforeShops.length = 0;
          // console.log(response.data)
          for (var i = 0; i < response.data.length; i++) {
            _this.shopList.push(response.data[i].est_shop_id);
            _this.beforeShops.push(response.data[i].est_shop_id);
            // console.log(_this.shopList)
          }

          for (var k = 0; k < _this.rowsadj.length; k++) {
            for (var j = 0; j < response.data.length; j++) {
              if (
                _this.rowsadj[k].est_shop_id == response.data[j].est_shop_id
              ) {
                _this.$set(_this.rowsadj[k], "vgtSelected", true);
                // _this.shopList.push({est_shop_id:response.data[j].est_shop_id});
              }
            }
          }

          return Promise.resolve(true);
        })
        .catch(function (err) {
          console.log(err);
          return Promise.resolve(true);
        });
    },

    async setUserRole(email) {
      var _this = this;
      this.$http
        .get("/api/userroles?filter[where][est_user_id]=" + email)
        .then(function (response) {
          // console.log('role')
          // console.log(response.data)
          _this.roleList = response.data[0].role_id;
          for (var k = 0; k < _this.rows1.length; k++) {
            if (_this.rows1[k].role_id == response.data[0].role_id) {
              _this.$set(_this.rows1[k], "vgtSelected", true);
              break;
            }
          }
          return Promise.resolve(true);
        })
        .catch(function (err) {
          console.log(err);
          return Promise.resolve(true);
        });
    },

    Submit() {
      var _this = this;
      let ch = 156;
      this.onComplete("check", "false");
      if (this.submit_true == 0) {
        this.loading = true;
        var user = {
          checkbox: this.checkbox,
          usertype: this.usertype,
          username: this.user.name,
          email: this.user.email,
          password: this.user.pass,
          phone: this.user.phone,
          est_shop_id: this.shopList,
          roleList: this.roleList,
          update: this.updateedit,
          deletedshops: this.deletedshops,
          isAdmin: this.isAdmin,
          isSuperAdmin: this.isSuperAdmin,
          beforeShops: this.beforeShops,
        };
        if (this.updateedit === 0) {
          Promise.all([this.checkEmail(_this.user.email)]).then((user1) => {
            if (user1[0] == true) {
              this.loading = false;
              this.hasErrors.usereml = "Email Already Exist";
            } else if (user1[0] == 0) {
              this.$http
                .post("/api/users/insertuser", user)
                .then(function (response) {
                  _this.loading = false;
                  _this.reset();
                  _this.hasErrors.message = true;
                  _this.errorMessage.message = "User Added Successfully";
                  _this.shopuser();
                  _this.largeModal = false;
                  setTimeout(function () {
                    _this.hasErrors.message = false;
                    _this.errorMessage.message = null;
                  }, 6000);
                })
                .catch(function (error) {
                  _this.loading = false;
                  _this.hasErrors.message = true;
                  setTimeout(function () {
                    _this.hasErrors.message = false;
                    _this.errorMessage.message = null;
                  }, 6000);
                });
            } else {
            }
          });
        } else {
          this.$http
            .post("/api/users/insertuser", user)
            .then(function (response) {
              if (response.data.status == 444) {
                var data1 = "User is admin in ";
                var shp = response.data.data;
                var data = [];
                for (var i = 0; i < _this.rowsadj.length; i++) {
                  data.push({
                    Name: _this.rowsadj[i].est_shop_name,
                    Value: _this.rowsadj[i].est_shop_id,
                  });
                }
                for (var i = 0; i < shp.length; i++) {
                  var valObj = data.filter(function (elem) {
                    if (elem.Value == shp[i]) {
                      data1 = data1 + " " + elem.Name + ",";
                    }
                  });
                }
                _this.loading = false;
                _this.hasErrors.err_message = true;
                _this.errorMessage.err_message = data1;
                setTimeout(function () {
                  _this.hasErrors.err_message = false;
                  _this.errorMessage.err_message = null;
                }, 15000);
              } else {
                _this.loading = false;
                _this.reset();
                _this.hasErrors.message = true;
                _this.updateedit = 0;
                _this.errorMessage.message = "User Updated Successfully";
                _this.shopuser();
                _this.largeModal = false;
                setTimeout(function () {
                  _this.hasErrors.message = false;
                  _this.errorMessage.message = null;
                }, 6000);
              }
            })
            .catch(function (error) {
              _this.loading = false;
              _this.hasErrors.message = true;
              _this.errorMessage.message = error.response.data.error.message;
              setTimeout(function () {
                _this.hasErrors.message = false;
                _this.errorMessage.message = null;
              }, 6000);
            });
        }
      }
    },

    reset() {
      var _this = this;
      for (var k = 0; k < _this.rowsadj.length; k++) {
        _this.$set(_this.rowsadj[k], "vgtSelected", false);
      }
      for (var k = 0; k < _this.rows1.length; k++) {
        _this.$set(_this.rows1[k], "vgtSelected", false);
      }
      _this.hasErrors.usernm = "";
      _this.hasErrors.useradd = "";
      _this.hasErrors.userpin = "";
      _this.hasErrors.usereml = "";
      _this.hasErrors.userph = "";
      _this.hasErrors.password = "";
      _this.errorMessage.usershop = null;
      _this.errorMessage.usertypeerr = null;
      _this.usertype = "";
      _this.user.name = "";
      _this.shopid = null;
      _this.user.address = "";
      _this.user.pincode = "";
      _this.user.email = "";
      _this.user.pass = "";
      _this.user.phone = "";
      _this.user.conf = "";
      _this.roleList = null;
      _this.shopList = [];
      _this.temprow = null;
      _this.beforeShops = [];
    },

    deleteshoplist(shopid) {
      var _this = this;
      var id = shopid.id;
      this.$http
        .delete("/api/shopusers/" + id)
        .then(function (response) {
          _this.shopuser();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style>
.switch.switch-text .switch-label::before,
.switch.switch-text .switch-label::after {
  width: 67% !important;
}
.switch.switch-text {
  width: 74px;
}
.switch.switch-text .switch-input:checked ~ .switch-handle {
  left: 50px;
}
.switch.switch-text .switch-label {
  background-color: red;
}
.selected_row {
  background-color: blue;
}
.modal-title {
  color: black;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/User.vue